import React from 'react';

import { LISTING_TYPES, PRICE_VERIFICATION_STATUSES } from '../../util/listingTypes';
import verifiedPriceIcon from '../../assets/Verified_Price_icon.svg';
import unverifiedPriceIcon from '../../assets/Unverified_Price_icon.svg';

import css from './ListingPage.module.css';

const SectionPriceVerificationMaybe = props => {
  const { publicData = {} } = props;
  const listingType = publicData.listingType;

  if (listingType !== LISTING_TYPES.TICKET_SALE) {
    return null;
  }

  const priceVerificationStatus =
    publicData.price_verification_status || PRICE_VERIFICATION_STATUSES.UNVERIFIED;
  const isVerified = priceVerificationStatus === PRICE_VERIFICATION_STATUSES.VERIFIED;
  const icon = isVerified ? verifiedPriceIcon : unverifiedPriceIcon;
  const label = isVerified ? 'Verified price' : 'Price not verified';
  const body = isVerified
    ? "Verified fair price. The seller's price is not higher than what they paid."
    : "The seller's price is not verified yet. Their price may or may not be higher than what they paid.";

  return (
    <section className={css.priceVerificationSection}>
      <span
        className={`${css.priceVerificationPill} ${
          isVerified ? css.priceVerificationPillVerified : ''
        }`}
        role="img"
        aria-label={label}
      >
        <img
          className={css.priceVerificationPillImage}
          src={icon}
          alt=""
          aria-hidden="true"
          draggable="false"
        />
      </span>
      <p className={css.priceVerificationText}>{body}</p>
    </section>
  );
};

export default SectionPriceVerificationMaybe;
